/* =============================================

  Custom JS added by synq-ps.co.jp

=============================================== */

(function () {
  var BADGE_WRAPPER_SELECTOR = ".product-tile__promo-badge-wrapper";
  var OUTLET_BADGE_CLASS = "product-tile__promo-badge--outlet";
  var IMAGE_SELECTOR = ".product-tile__image";

  function appendOutletBadgeToProductTiles() {
    var images = document.querySelectorAll(IMAGE_SELECTOR);
    images.forEach(function (img) {
      var alt = (img.getAttribute("alt") || "").toLowerCase();
      if (!alt.includes("- outlet")) {
        return;
      }
      
      var imageLink = img.closest("a");
      if (!imageLink) {
        return;
      }

      var badgeWrapper = imageLink.nextElementSibling;
      if (!badgeWrapper || !badgeWrapper.matches(BADGE_WRAPPER_SELECTOR)) {
        badgeWrapper = imageLink.parentElement
          ? imageLink.parentElement.querySelector(BADGE_WRAPPER_SELECTOR)
          : null;
      }

      if (!badgeWrapper) {
        return;
      }

      if (badgeWrapper.querySelector("." + OUTLET_BADGE_CLASS)) {
        return;
      }

      badgeWrapper.insertAdjacentHTML(
        "afterbegin",
        '<div class="product-tile__promo-badge product-tile__promo-badge--outlet"><div class="product-tile__promo-badge-text">OUTLET</div></div>'
      );
    });
  }

  function startDomObserver() {
    if (!document.body) {
      return;
    }

    var observer = new MutationObserver(function (mutations) {
      var shouldRescan = mutations.some(function (mutation) {
        if (mutation.type === "attributes") {
          if (!(mutation.target instanceof Element)) {
            return false;
          }
          return mutation.target.matches(IMAGE_SELECTOR);
        }

        if (mutation.type === "childList" && mutation.addedNodes.length) {
          return Array.from(mutation.addedNodes).some(function (node) {
            if (!(node instanceof Element)) {
              return false;
            }

            return node.matches(IMAGE_SELECTOR) || !!node.querySelector(IMAGE_SELECTOR);
          });
        }

        return false;
      });

      if (shouldRescan) {
        appendOutletBadgeToProductTiles();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["alt"]
    });
  }

  function initOutletBadge() {
    appendOutletBadgeToProductTiles();
    startDomObserver();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initOutletBadge);
  } else {
    initOutletBadge();
  }
})();
